/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CodemirrorFieldComponent} from '../../common/directives/codemirror-field.component';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {EntityDiagramComponent} from '../../common/directives/html/entity-diagram-component';
import {AdminRichTextFieldComponent} from '../../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../../common/directives/notes/object-notes-button.component';
import {RouteViewsModule} from '../../common/directives/route-views.module';
import {CreativeAssetsModule} from '../../creative/creative-assets.module';
import {AdDensityPageComponent} from './ad-density-page.component';
import {AdTransparencyPreviewPageComponent} from './ad-transparency-preview-page.component';
import {AdnInvoicingPageComponent} from './adn-invoicing/adn-invoicing-page.component';
import {ChainCountsPageComponent} from './chain-counts-page.component';
import {CreativeCheckerPageComponent} from './creative-checker-page.component';
import {ElectionsListPageComponent} from './elections-list-page.component';
import {NetworkOverviewPageComponent} from './network-overview-page.component';
import {PoliticalOverlayPreviewPageComponent} from './political-overlay-preview-page.component';
import {PoliticalPreviewPageComponent} from './political-preview-page.component';
import {PoliticalSponsorsPageComponent} from './political-sponsors-page.component';
import {PreviewShotterPageComponent} from './preview-shotter-page.component';
import {ReleaseNoteAssetUploadComponent} from './release-note-asset-upload.component';
import {ReleaseNoteCardComponent} from './release-note-card.component';
import {ReleaseNotesDisplayComponent} from './release-notes-display.component';
import {ReleaseNotesEditPageComponent} from './release-notes-edit-page.component';
import {ReleaseNotesEditTitleComponent} from './release-notes-edit-title.component';
import {ReleaseNotesListPageComponent} from './release-notes-list-page.component';
import {ReleaseNotesModalComponent} from './release-notes-modal.component';
import {ScanResultsPageComponent} from './scan-results-page.component';
import {ShotterPageComponent} from './shotter-page.component';
import {StructurePageComponent} from './structure-page.component';
import {SupportPageComponent} from './support-page.component';
import {SupportingPagesPageComponent} from './supporting-pages-page.component';
import {TcfPageComponent} from './tcf-page.component';
import {TestStylePageComponent} from './test-style-page.component';
import {TfaRecoveryPageComponent} from './tfa-recovery-page.component';
import {TransparencyShotterPageComponent} from './transparency-shotter-page.component';
import {VersionCopyPageComponent} from './version-copy-page.component';
import {VersionHistoryPageComponent} from './version-history-page.component';

const SIMPLE_PAGES = [
  AdDensityPageComponent,
  AdTransparencyPreviewPageComponent,
  AdnInvoicingPageComponent,
  ChainCountsPageComponent,
  CreativeCheckerPageComponent,
  ElectionsListPageComponent,
  EntityDiagramComponent,
  NetworkOverviewPageComponent,
  PoliticalOverlayPreviewPageComponent,
  PoliticalPreviewPageComponent,
  PoliticalSponsorsPageComponent,
  PreviewShotterPageComponent,
  ReleaseNoteAssetUploadComponent,
  ReleaseNoteCardComponent,
  ReleaseNotesDisplayComponent,
  ReleaseNotesEditPageComponent,
  ReleaseNotesEditTitleComponent,
  ReleaseNotesListPageComponent,
  ReleaseNotesModalComponent,
  ScanResultsPageComponent,
  ShotterPageComponent,
  StructurePageComponent,
  SupportPageComponent,
  SupportingPagesPageComponent,
  TcfPageComponent,
  TestStylePageComponent,
  TfaRecoveryPageComponent,
  TransparencyShotterPageComponent,
  VersionCopyPageComponent,
  VersionHistoryPageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    TabsModule,
    AdminListModule,
    CodemirrorFieldComponent,
    CreativeAssetsModule,
    FormControlsModule,
    AdminRichTextFieldComponent,
    NotesComponent,
    ObjectNotesButtonComponent,
    RouteViewsModule
  ],
  declarations: SIMPLE_PAGES,
  exports: SIMPLE_PAGES
})
export class SimplePagesModule {
}
